module.exports = __webpack_public_path__ + "roboto-bold-webfont.2535432acf2f4bdb8fd3.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-bold-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-bold-webfont.svg
// module chunks = styles